import Colors from '@riseupil/base-ui/src/scss/riseup-js-colors.module.scss';

export const availableEmojis = ['🥨', '🪐', '🤖', '👾', '🐼', '🐨', '🦋', '🐙', '🐠', '🐋', '🐊', '🌴', '🪴', '🌸',
  '🌼', '🌻', '🌞', '🌛', '🍉', '🍓', '🍇', '🥝', '🥬', '🥐', '🧀', '🥯', '🥙', '🌮', '🍕', '🍟', '🥗', '🫕', '🥟',
  '🍣', '🍦', '🧁', '🍫', '🍿', '🍩', '🍬', '🍪', '️🧃', '🚀', '⛵', '💎', '🎀', '🌈', '⚽', '🎾'];
export const availableColors = [Colors.riseup_light_orange, Colors.riseupRed, Colors.riseupYellow, Colors.riseupGreen,
  Colors.riseupBlue, Colors.riseupLightRed, Colors.riseupLightGreen, Colors.riseupLightBlue];
